export default defineAppConfig({
    name: 'Zara Mills',
    builderKey: 'fd4f408d9bdb448f9e14831e0cdf3ef4',
})
